export type ShellLeadingControl = 'menu' | 'back' | 'close' | 'none'
export type ShellOwnerTab = 'home' | 'bills' | 'representatives' | 'actions' | null

export interface ShellPresentation {
  leadingControl: ShellLeadingControl
  bottomNav: boolean
  ownerTab: ShellOwnerTab
  focused: boolean
  ownerKey: string | null
}

const ROOTS = new Set(['/', '/bills', '/representatives', '/actions'])

export function shellOwnerKey(pathname: string, search = '', locationKey = ''): string {
  return `${pathname}${search}::${locationKey}`
}

export function getShellPresentation(pathname: string, search = ''): ShellPresentation {
  const params = new URLSearchParams(search)
  const reader = pathname.startsWith('/bills/') && params.get('reader') === 'text'
  const questionnaire = pathname === '/profile/values/questionnaire'
  if (ROOTS.has(pathname)) return { leadingControl: 'menu', bottomNav: true, ownerTab: pathname === '/' ? 'home' : pathname.slice(1) as ShellOwnerTab, focused: false, ownerKey: null }
  if (questionnaire) return { leadingControl: 'close', bottomNav: false, ownerTab: null, focused: true, ownerKey: pathname }
  if (reader) return { leadingControl: 'close', bottomNav: false, ownerTab: 'bills', focused: true, ownerKey: pathname }
  if (/^\/bills\/[^/]+\/roll-call\//.test(pathname)) return { leadingControl: 'back', bottomNav: true, ownerTab: 'bills', focused: false, ownerKey: pathname }
  if (pathname.startsWith('/bills/')) return { leadingControl: 'back', bottomNav: true, ownerTab: 'bills', focused: false, ownerKey: pathname }
  if (pathname.startsWith('/representatives/')) return { leadingControl: 'back', bottomNav: true, ownerTab: 'representatives', focused: false, ownerKey: pathname }
  if (pathname.startsWith('/actions/')) return { leadingControl: 'back', bottomNav: true, ownerTab: 'actions', focused: false, ownerKey: pathname }
  return { leadingControl: 'back', bottomNav: false, ownerTab: null, focused: false, ownerKey: pathname }
}
